var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBriefcaseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.36523H4C2.89543 7.36523 2 8.26066 2 9.36523V19.3652C2 20.4698 2.89543 21.3652 4 21.3652H20C21.1046 21.3652 22 20.4698 22 19.3652V9.36523C22 8.26066 21.1046 7.36523 20 7.36523Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3652V5.36523C16 4.8348 15.7893 4.32609 15.4142 3.95102C15.0391 3.57595 14.5304 3.36523 14 3.36523H10C9.46957 3.36523 8.96086 3.57595 8.58579 3.95102C8.21071 4.32609 8 4.8348 8 5.36523V21.3652",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBriefcaseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BriefcaseIcon.ce2bf50845989580e6f154420cf78f40.svg";